module.exports = __webpack_public_path__ + "img/Tessellate47.91ad07f4.jpg";